export const paginationOptions = {
    showSizeChanger: true,
    showQuickJumper: false,
    pageSizeOptions: ['10', '25', '50', '100'],
    position: ['bottomRight'],
    size: 'default',
    showTotal: (total, range) => `${range[0]} - ${range[1]} di ${total}`,
};
